import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import Table from "../../../../Components/Table";
import OrSpinner from "../../../../Components/Utils/OrSpinner";

import { IGestaoProdutosVinculados } from "../../../../Interfaces/Vendas/GestaoProdutoVinculados/GestaoProdutosVinculadosInterface";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IEtapasVinculadasGrupoProps {
    idEquipeVendas: number;
    handleDesvincularTodosAtributoDeleteGestaoProdutos(): void;
    handleDesvincularAtributoUnicoDeleteGestaoProdutos(
        row: IGestaoProdutosVinculados
    ): void;
    lstSelecionadosDeleteGestaoProdutos: React.MutableRefObject<
        IGestaoProdutosVinculados[]
    >;
    lstProdutosVinculadosPorVenda: IGestaoProdutosVinculados[] | undefined;
    lstProdutosVinculadosPorVendaLoading: boolean;
    ListarProdutosVinculadosPorVenda: (
        ...args: any[]
    ) => Promise<IGestaoProdutosVinculados[]>;
    DeleteEquipeVendasLoadingGestaoProdutos: boolean;
}

export default function ProdutosVinculados(props: IEtapasVinculadasGrupoProps) {
    const columns: Array<ColumnDescription<IGestaoProdutosVinculados>> = [
        {
            dataField: "DS_PRODUTO_PAI",
            text: "Empreendimento",
        },
        {
            dataField: "DS_PRODUTO",
            text: "Unidade",
        },
        {
            dataField: "DS_STATUS",
            text: "Status",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <div
                        style={{ color: CorDaStatusProduro(row), fontSize: 16 }}
                    >
                        {row.DS_STATUS}
                    </div>
                </div>
            ),
        },
        {
            dataField: "ID_EQUIPE_VENDAS",
            text: "",
            isDummyField: true,

            formatter: (_, row) => (
                <div className="Button-Tools d-flex justify-content-center align-items-center">
                    <button
                        className="btn btn-outline-danger font-weight-bold mr-2"
                        onClick={() => {
                            props.handleDesvincularAtributoUnicoDeleteGestaoProdutos(
                                row
                            );
                        }}
                        disabled={props.DeleteEquipeVendasLoadingGestaoProdutos}
                    >
                        <FontAwesomeIcon
                            icon={faArrowDown}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Desvincular
                    </button>
                </div>
            ),
        },
    ];
    function CorDaStatusProduro(row: IGestaoProdutosVinculados) {
        if (row.DS_STATUS === "VENDIDO") {
            return "red";
        } else if (row.DS_STATUS === "DISPONÍVEL") {
            return "green";
        } else if (row.DS_STATUS === "RESERVADO") {
            return "DarkMagenta";
        } else if (row.DS_STATUS === "PERMUTADO") {
            return "orange";
        }
    }

    const selectRowProp: SelectRowProps<IGestaoProdutosVinculados> = {
        mode: "checkbox",
        clickToSelect: true,
        selected: props.lstSelecionadosDeleteGestaoProdutos.current.map(
            (p) => p.ID_PRODUTO
        ),

        onSelect: (row, isSelect) => {
            row.FL_MARC = isSelect;
            const lstAtributosMarcados =
                props.lstProdutosVinculadosPorVenda?.filter((p) => p.FL_MARC) ??
                [];

            props.lstSelecionadosDeleteGestaoProdutos.current =
                lstAtributosMarcados;
        },

        onSelectAll: (isSelect, rows: Array<IGestaoProdutosVinculados>) => {
            rows.forEach((row) => {
                row.FL_MARC = isSelect;
            });

            props.lstSelecionadosDeleteGestaoProdutos.current =
                props.lstProdutosVinculadosPorVenda?.filter((p) => p.FL_MARC) ??
                [];
        },
    };

    return (
        <OrSpinner
            loading={props.lstProdutosVinculadosPorVendaLoading}
            spinner="capys"
        >
            <Table
                data={props.lstProdutosVinculadosPorVenda ?? []}
                columns={columns}
                keyField="ID_PRODUTO"
                selectRow={selectRowProp}
                noDataIndication={
                    <div className="text-center text-muted">Nenhuma etapa</div>
                }
                loading={props.lstProdutosVinculadosPorVendaLoading}
                wrapperClasses="wrapperTable mw-100 x-scroll"
                classes="tableClasses"
                bordered={false}
                center
                defaultStyle={{
                    align: "center",
                    classes: "p-2",
                }}
            />
            <div className="d-flex col-12 justify-content-center mb-3">
                <button
                    className="btn btn-outline-danger"
                    onClick={() =>
                        props.handleDesvincularTodosAtributoDeleteGestaoProdutos()
                    }
                >
                    Desvincular Selecionados
                </button>
            </div>
        </OrSpinner>
    );
}
